import { Component, Vue } from 'vue-property-decorator'
import { setCustomerConversionBackByCustomerConversionId } from '@/api/customer'
import { getMessageReviewById } from '@/api/message'
import { formatDate } from '@/utils/timeFilter'

@Component({})
export default class CancelBackClue extends Vue {
    tableData = []
    operationShow = true
    logData = []
    id: number;
    page = 1
    limit = 20
    total = 0
    formatDate = formatDate
    infoData: any = ''
    loading = false
    status: number;
    dialog = false
    types  = ''

    created() {
        this.status = Number(this.$route.query.status)
        this.id = Number(this.$route.query.id)
        this.types  = this.$route.query.types?this.$route.query.types as string:''
        this.getData()
    }

    async getData() {
        const data: any = await getMessageReviewById(this.id,this.types)
        this.infoData = data.result
        this.logData = data.result.messageReviewLogList
        this.$nextTick(() => {
            (this.$refs['table'] as HTMLFormElement).bodyWrapper.addEventListener('scroll', (res: any) => {
                const height = res.target;
                const clientHeight = height.clientHeight;
                const scrollTop = height.scrollTop;
                const scrollHeight = height.scrollHeight;
                if (clientHeight + scrollTop >= scrollHeight) {
                    if (this.tableData.length >= this.total) {

                        return
                    }
                    this.limit += 20
                    this.getTableData()
                }
            }, true);
        })
        this.getTableData()
    }

    async getTableData() {
        const data: any = await getMessageReviewById(this.id,this.types)
        this.tableData = data.result.customerConversionFollowList
        this.total = this.tableData.length
    }

    onOpen(url: string) {
        window.open(url, '_blank')
    }
    async cancelApproval() {
        await setCustomerConversionBackByCustomerConversionId(this.infoData.id)
        this.$message.success('撤销回退线索成功')
        this.dialog = false
        setTimeout(() => {
            window.close()
        }, 1500)
        // })

    }
}
